<template>
  <div class="">
    <vue-headful v-if="getTitle" :title="getTitle" />
    <div class="">
      <fader>
        <h1
          v-cloak
          class=" flex font-light justify-center text-accent text-inherit-size mb-6"
          data-test="pageHeading"
          v-show="$slots.heading"
        >
          <slot name="heading">
            Heading
          </slot>
        </h1>
      </fader>

      <slot></slot>
    </div>

    <p v-if="$slots.after" class="text-xs text-accent-60 text-center">
      <slot name="after"></slot>
    </p>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ``,
    },
  },
  computed: {
    getTitle() {
      return this.title !== `` ? `${this.title} | BattleFX` : false
    },
  },
}
</script>
